import { render } from "./PopupType1.vue?vue&type=template&id=fc5f1e2a"
import script from "./PopupType1.vue?vue&type=script&lang=js"
export * from "./PopupType1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__